import { supplierListQuerySchema } from '@chukua/common';
import { Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { useRemoteSearchOptions } from '../../../../../shared/hooks/use-remote-search-options';
import { listSuppliers } from '../../suppliers/suppliers.api';

const PAGE_SIZE = 20;

interface SupplierSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  /** The saved supplier's name, so it shows rather than its id when the form reopens on a supplier the first page doesn't hold. */
  savedName?: string | null;
}

/** Remote-search picker over the active parts suppliers, opening on the first page. */
export function SupplierSelect({ id, value, onChange, savedName }: SupplierSelectProps) {
  const fetchSuppliers = useCallback(
    (q: string | undefined) =>
      listSuppliers(supplierListQuerySchema.parse({ q, status: ['active'], pageSize: PAGE_SIZE })).then((page) =>
        page.items.map((supplier) => ({ value: supplier.id, label: supplier.name })),
      ),
    [],
  );
  const { pin, selectProps } = useRemoteSearchOptions(fetchSuppliers);

  useEffect(() => {
    if (value && savedName) pin({ value, label: savedName });
  }, [value, savedName, pin]);

  return (
    <Select
      {...selectProps}
      id={id}
      value={value}
      onChange={onChange}
      allowClear
      placeholder="Select or search suppliers"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No suppliers found'}
    />
  );
}
